import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { getLocalStorage } from "../utils/LocalStorage.utils";
const permissionsStorageKey = `${import.meta.env.VITE_SESSION_PREFIX}-permissions-data`;
const PermissionContext = createContext(undefined);
export const PermissionProvider = ({ children }) => {
    const storedPermissions = getLocalStorage(permissionsStorageKey);
    const permissions = useMemo(() => (storedPermissions ?? []).filter(Boolean), [storedPermissions]);
    const value = useMemo(() => ({
        permissions,
        hasPermission: (permission) => permissions.includes(permission),
        hasAnyPermissions: (requestedPermissions) => requestedPermissions.some((permission) => permissions.includes(permission)),
        hasAllPermissions: (requestedPermissions) => requestedPermissions.every((permission) => permissions.includes(permission))
    }), [permissions]);
    return (_jsx(PermissionContext.Provider, { value: value, children: children }));
};
export const usePermissions = () => {
    const context = useContext(PermissionContext);
    if (!context) {
        throw new Error("usePermissions must be used within a PermissionProvider.");
    }
    return context;
};
